import { useState, ReactNode } from 'react'
import './AdvancedDrawer.css'

interface AdvancedDrawerProps {
  children: ReactNode
  buttonLabel?: string
}

function AdvancedDrawer({ children, buttonLabel = '⚙ Advanced reasoning detail' }: AdvancedDrawerProps) {
  const [open, setOpen] = useState(false)
  return (
    <div className={`advanced-drawer ${open ? 'open' : ''}`}>
      <button
        type="button"
        className="advanced-drawer-toggle"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        {buttonLabel}
      </button>
      {open && <div className="advanced-drawer-content">{children}</div>}
    </div>
  )
}

export default AdvancedDrawer
